// extracted by mini-css-extract-plugin
export var active = "_bx-2";
export var highlight = "_bx-1";
export var highlightLayer = "_bx-0";
export var issuePopover = "_bx-3";
export var statusIcon = "_bx-4";